import { Language } from '@powerduck/common/enums/language';
import { AppState } from '../app-state';
import type { IAppResources } from './_IAppResources';


export class LanguageProvider {
	static resCache: any = {};
	static failedDownloads: any = {};
	static fallbackLanguage = Language.en;

	static async loadLanguage(language: Language): Promise<boolean> {
		let resPack: IAppResources;
		if (language == Language.sk) {
			try {
				resPack = LanguageProvider.getImportedObj((await import('./sk.json')) as any);
				LanguageProvider.resCache[language] = resPack;
			} catch (e) {
				LanguageProvider.failedDownloads[language] = true;
			}
		} else if (language == Language.en) {
			try {
				resPack = LanguageProvider.getImportedObj((await import('./en.json')) as any);
				LanguageProvider.resCache[language] = resPack;
			} catch (e) {
				LanguageProvider.failedDownloads[language] = true;
			}
		} else if (language == Language.cs) {
			try {
				resPack = LanguageProvider.getImportedObj(await import('./cs.json') as any);
				LanguageProvider.resCache[language] = resPack;
			} catch (e) {
				LanguageProvider.failedDownloads[language] = true;
			}
		} else if (language == Language.pl) {
			try {
				resPack = LanguageProvider.getImportedObj(await import('./pl.json') as any);
				LanguageProvider.resCache[language] = resPack;
			} catch (e) {
				LanguageProvider.failedDownloads[language] = true;
			}
		} else if (language == Language.de) {
			try {
				resPack = LanguageProvider.getImportedObj(await import('./de.json') as any);
				LanguageProvider.resCache[language] = resPack;
			} catch (e) {
				LanguageProvider.failedDownloads[language] = true;
			}
		}

		return true;
	}

	static getImportedObj(importedObj: any): any {
		if (importedObj != null && (importedObj.__esModule == true || importedObj.default != null)) {
			return { ...importedObj.default };
		}

		return { ...importedObj };
	}

	static needsReload(): boolean {
		return LanguageProvider.resCache[AppState.currentLanguage] == null;
	}

	static postProcessLanguage(language: Language): void {
		if (LanguageProvider.resCache[language] != null) {
			const langPack = LanguageProvider.resCache[language];
			const defLanguage = LanguageProvider.resCache[LanguageProvider.fallbackLanguage];

			for (const key in defLanguage) {
				if (langPack[key] == null) {
					langPack[key] = defLanguage[key];
				}
			}
		}
	}

	public static async ensureLanguage(): Promise<boolean> {
		const promiseArr: Promise<boolean>[] = [];
		const currentLanguage = AppState.currentLanguage;
		const fallbackLanguage = LanguageProvider.fallbackLanguage;

		if (LanguageProvider.resCache[fallbackLanguage] == null) {
			promiseArr.push(LanguageProvider.loadLanguage(fallbackLanguage));
		}

		if (
			currentLanguage != fallbackLanguage
			&& LanguageProvider.failedDownloads[currentLanguage] != true
			&& LanguageProvider.needsReload()
		) {
			promiseArr.push(LanguageProvider.loadLanguage(currentLanguage));
		}

		if (promiseArr.length > 0) {
			await Promise.all(promiseArr);
			if (currentLanguage != fallbackLanguage) {
				LanguageProvider.postProcessLanguage(currentLanguage);
			}
		}

		(window as any).__langProvider = LanguageProvider;
		return true;

	}

	public static getResourcePack(language: Language): IAppResources {
		let retVal = LanguageProvider.resCache[language];
		if (retVal == null) {
			retVal = LanguageProvider.resCache[LanguageProvider.fallbackLanguage];
		}

		if (retVal == null) {
			// Try Slovak as primary fallback
			retVal = LanguageProvider.resCache[Language.sk];
		}

		if (retVal == null) {
			// Return any available language pack
			const availableLanguages = Object.keys(LanguageProvider.resCache);
			if (availableLanguages.length > 0) {
				retVal = LanguageProvider.resCache[availableLanguages[0]];
			}
		}

		return retVal;
	}

	public static loadDefaultLanguage(resPack): void {
		LanguageProvider.resCache[LanguageProvider.fallbackLanguage] = resPack;
	}
}
